import { FlexboxGridTableColumn } from './components/FlexboxGridTable/FlexboxGridTable';
import { DetailsProdutoContent } from './types';

export const FILTER_LABEL_LIST = ['ANALISAR', 'EM', 'LOCAL', 'PERIODO'];

/** Limite de redes por pedido — alinhado a ValidationConstants no isa-omnichannel-comparison-engine (detail/download). */
export const OMNICHANNEL_MAX_REDES = 10;
export const OMNICHANNEL_MAX_REDES_MESSAGE = 'Máximo de 10 redes permitidas';

export const LOCAL_TYPE_LIST = [
  { label: 'Cidade', value: 'CIDADE' },
  { label: 'UF', value: 'UF' },
  { label: 'Todo o território', value: 'TODO_TERRITORIO' },
];

export const WEEK_PERIOD_LIST = [
  { label: 'Últimas 4 semanas', value: 4 },
  { label: 'Últimas 8 semanas', value: 8 },
  { label: 'Últimas 12 semanas', value: 12 },
];

export const PAGE_BLOCKER = {
  title: 'Tenha visão completa dos preços por canal e otimize sua competitividade.',
  subtitle: 'Disponível em outros planos do InfoPanel.',
  buttonText: 'quero o teste grátis',
};

export const SPEAK_WITH_SPECIALIST_TITLE = {
  title: 'Potencialize sua estratégia de preços por canal.',
  subtitle: 'Converse com um de nossos especialistas e descubra todos os benefícios do Módulo Omnichannel.',
};

export const MAX_PRODUCT_SELECTION = 1000;

export const PRODUCT_TYPE_LIST = [
  {
    label: 'Todos os produtos',
    value: 'TODOS',
  },
  {
    label: 'Produtos específicos',
    value: 'ESPECIFICOS',
  },
];

export const LOCALE = { noResultsText: 'Nenhum item encontrado', searchPlaceholder: 'Buscar item' };

export const OPTIONS_DROPDOWN = [
  {
    key: 'csv',
    label: 'Download em CSV',
  },
  {
    key: 'xlsx',
    label: 'Download em XLS',
  },
];

export const DETAILING_TABLE_COLUMNS: FlexboxGridTableColumn<DetailsProdutoContent>[] = [
  { key: 'PRODUTO', label: 'Produto' },
  {
    key: 'PRECO_CANAL_FISICO',
    label: 'Preço canal físico',
    sortable: false,
  },
  {
    key: 'PRECO_SITES_PROPRIOS',
    label: 'Sites próprios',
    sortable: true,
  },
  {
    key: 'PRECO_APPS_ENTREGA',
    label: 'Apps de entrega',
    sortable: true,
  },
];
